<div class="flex items-center h-full" cdkMonitorSubtreeFocus (cdkFocusChange)="_updateFocus($event)">
  <div class="relative overflow-hidden min-w-[56px] max-w-[calc(50%-4px)]" [class.pointer-events-none]="!allowFreeText">
    <ng-content select="input[matStartDate]"></ng-content>
    <div class="select-none invisible whitespace-nowrap inline-block min-w-[2px] font-semibold sm:text-normal" aria-hidden="true">
      {{_getStartInputMirrorValue()}}
    </div>
  </div>

  @if (_getStartInputMirrorValue() || _getEndInputMirrorValue()) {
  <span
    class="my-0 mx-1 transition-all pointer-events-none text-action-primary sm:text-normal"
    [ngClass]="disabled
        ? '[&&]:text-custom-disabled-input-color'
        : ''"
  >
    {{separator}}
  </span>
  }

  <div class="relative overflow-hidden min-w-[56px] max-w-[calc(50%-4px)]" [class.pointer-events-none]="!allowFreeText">
    <ng-content select="input[matEndDate]"></ng-content>
    <div class="select-none invisible whitespace-nowrap inline-block min-w-[2px] font-semibold sm:text-normal" aria-hidden="true">
      {{_getEndInputMirrorValue()}}
    </div>
  </div>
</div>
